import { observable, makeObservable } from 'mobx'
import uuidv4 from 'uuid/v4'
import { mapToJSON } from '../utils/helpers'

class HeaderGroup {
    @observable options

    /**
     * @param {UUID} options.id
     * @param {Array<UUID>} options.options
     * @param {Boolean} options.isHidden
     * @param {string=} options.image
     * @param {Map<string, QuestionLang>} options.title
     */
    constructor({
        id,
        options = [],
        isHidden = false,
        image,
        title,
    }) {
        makeObservable(this)
        this.id = id || uuidv4()
        this.isHidden = isHidden
        this.options = options
        this.image = image
        this.title = title instanceof Map
            ? title
            : new Map(Object.entries(title || {})
                .map(([langCode, lang]) => ([langCode, lang])))
    }

    toJSON() {
        return {
            id: this.id,
            isHidden: this.isHidden,
            image: this.image,
            options: this.options,
            title: mapToJSON(this.title),
        }
    }
}

export default HeaderGroup
